import React, {
	Component,
} from 'react';



class ColumnsManagementElements extends Component {

	render() {
		const {
			children,
		} = this.props;

		return (
			<div className="columns-management-elements">
				{children}
			</div>
		);
	}

}



export default ColumnsManagementElements;
